export const emailValidatorNoPhone =
  'A valid email is required if no phone number is provided.'
export const emailValidatorText = 'Please enter a valid email.'
export const invalidDateText = 'Date must be in a valid format.'
export const invalidIntegerText = 'Response must be an integer.'
export const invalidYearText = 'Response must be a year (4 digits).'
export const missingEmailAndPhoneErrorMessage =
  'At least one of a valid email or valid phone number must be provided.'
export const phoneValidatorNoEmail =
  'A valid phone number is required if no email is provided.'
export const phoneValidatorText = 'Please enter a valid phone number.'
